import {constants} from "@/constants";
import {urlChatID} from "@/utils/url.js";
export const apiParserStatus = async function() {
    let res = await fetch(`${constants.url.API_PREFIX}chatbot/${urlChatID()}/parse/status`)
    return res.json()
}

export const apiParserStop = async function() {
    return await fetch(`${constants.url.API_PREFIX}chatbot/${urlChatID()}/parse/stop`)
}